<template>
  <v-row class="pt-5">
    <v-col cols="10" offset="1">
      <TilesResultsCore v-if="resultsModule === 'core'" :doc="doc" :fields="fields" />
      <TilesResultsBasic v-else-if="resultsModule === 'basic'" :doc="doc" :fields="fields" />
      <TilesResultsExtended v-else :doc="doc" :fields="fields" />
    </v-col>

    <v-col cols="10" offset="1">
      <v-row v-if="doc && tiles">
        <div v-for="card in tiles" :key="card.id" :data-id="card.id" :style="{ width: computedWidth }">
          <show-card v-if="card" :card="card" :cols="cols"></show-card>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { ShowCard } from "@/components/core";
import { TilesResultsCore, TilesResultsExtended, TilesResultsBasic } from "@/components/results/tiles-survey/modules";

export default {
  name: "ResultsTileUser",
  data() {
    return {
      doc: null,
      cols: 4,
    };
  },
  props: {
    uid: String,
    model: String,
    localTiles: Array,
    resultsModule: {
      type: String,
      default: 'core'
    },
    // step 1 field definitions from the project content file
    fields: {
      type: Array,
      default: () => [],
    }
  },
  components: {
    ShowCard,
    TilesResultsCore,
    TilesResultsBasic,
    TilesResultsExtended
  },
  mounted() {
    this.getExercise(this.uid);
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  computed: {
    computedWidth() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    },
    tiles() {
      if (this.doc.gridSlots && this.doc.gridSlots.length) {
        return this.doc.gridSlots
      } else if (this.doc.selectedTiles && this.doc.selectedTiles.length) {
        return this.doc.selectedTiles
      } else {
        return []
      }
    }
  },
  methods: {
    getExercise(id) {
      // this.doc = null;
      let ref = fb[this.model]
        .where("id", "==", id)
        .where("pid", "==", this.$route.params.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.cols = items[0].gridCols;
            this.doc = items[0];
          }
        })
        .catch(function () { });
    },
  },
};
</script>
